<template>
  <div class="flex-space-between subscribe-header">
    <div class="back" @click="goBack">
      <img src="@/assets/img/mobile/icon-back.png" alt="">
    </div>
    <div class="title">{{ $t("common.nav_credits") }}</div>
    <div class="flex-center fixed-right">
      <div class="invite" @click="handleInvite">
        <img src="@/assets/img/gift.png" alt="" />
      </div>
      <div v-if="userDataStore.isLogin">
        <div
          class="credit flex-row-center"
          v-if="userDataStore?.userInfo?.user?.is_vip"
        >
          <img src="@/assets/img/credit.png" alt="" />
          <span
            >{{ $t("library.Credits") }}:{{ userDataStore?.credits || 0 }}</span
          >
        </div>
        <div class="subcribe" v-else>{{ $t("create.subscribe") }}</div>
      </div>
      <div v-else class="try" @click="showLogin">
        {{ $t("mine.try_free_now") }}
      </div>
      <div class="avatar flex-center" v-if="userDataStore.isLogin">
        <div class="mobile">
          <img
            :src="
              userDataStore?.userInfo?.user?.profile_image
                ? getObjectStorageFullUrl(
                    userDataStore?.userInfo?.user?.profile_image
                  )
                : defaultLogin
            "
            alt="header"
            @click="goRouter('profile')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  getCurrentInstance,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import useUserDataStore from "@/store/userDataStore";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import { funComponentList } from "@/components/functionComp/index";
import ShowInviteDialog from "@/components/inviteDialog/inviteDialog.js";

const Router = useRouter();
const route = useRoute();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const userDataStore = useUserDataStore();

const goBack = () => {
  Router.go(-1)
}

const handleInvite = () => {
  if (userDataStore.isLogin) {
    ShowInviteDialog();
  } else {
    showLogin();
  }
  globalProperties.logClickEvent("Invite_for_free_credits", {});
};

const goRouter = (name) => {
  Router.push({
    name: name,
    query: {
      origin: route.name,
    },
  });
};

const showLogin = () => {
  userDataStore.checkLoginStatus()
  // funComponentList.ThirdLogin({
  //   handleOk: (str) => {
  //     console.log("点击成功" + str);
  //     console.log("userDataStore.isLogin", userDataStore.isLogin);
  //   },
  // });
};
</script>

<style lang="scss" scoped>
.subscribe-header {
  padding: 0 16px;
  color: #fff;
  .back {
    margin-right: 12px;
    img {
      width: 40px;
      height: 40px;
    }
  }
  .title {
    line-height: 32px;
    font-size: 24px;
    font-weight: 600;
    line-height: 60px;
    color: #fff;
    text-transform: capitalize;
  }
  .invite {
    padding: 6px 14px;
    margin-right: 8px;
    border-radius: 50px;
    background: rgba(148, 173, 255, 0.2);
    img {
      display: block;
      width: 16px;
      height: 16px;
    }
  }
  .credit {
    padding: 4px 12px;
    border-radius: 20px;
    background: rgba(148, 173, 255, 0.2);
    img {
      width: 16px;
      height: 16px;
      display: block;
      margin-right: 4px;
    }
    span {
      font-size: 12px;
      line-height: 20px;
      color: #fff;
    }
  }
  .subcribe {
    padding: 4px 12px;
    background: linear-gradient(92deg, #4fdeff -39%, #d9f8ff 52%, #e675ff 132%);
    color: #000;
    font-size: 12px;
    line-height: 20px;
    border-radius: 20px;
  }
  .avatar {
    border-radius: 50%;
    margin-left: 8px;
    // height: 40px;
    display: none;
    align-items: center;
    &:hover {
      opacity: 0.8;
    }
    img {
      border-radius: 50%;
      width: 32px;
      height: 32px;
    }
    .mobile {
      display: none;
    }
  }
  @media (max-width: 768px) {
    .avatar {
      display: flex;
      img {
        display: block;
        width: 26px;
        height: 26px;
      }
      .mobile {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .pc {
        display: none;
      }
    }
  }
}
</style>
